
import _ from 'lodash'
import { Component } from 'react'

import ROS from '../../../../../lib/IssueMapping/ReviewOfSystems'
import {
  bindTargetMixin,
  CancelButton,
  CheckboxInput,
  SaveButton
} from '../../../../shared/FormBuilder'
import { Svg } from '../../../../shared/NarusMaterial'

import {
  AllergiesForm,
  CardiovascularForm,
  DigestiveForm,
  EndocrineForm,
  EnteForm,
  GeneralForm,
  GenitourinaryForm,
  HematologicForm,
  IntegumentaryForm,
  MentalHealthForm,
  MusculoskeletalForm,
  NeurologicalForm,
  RespiratoryForm
} from './components'
import SectionHeader from './sectionHeader'
import './styles.scss'

const style = {
  categoryItemContainer: {
    display: 'inline-block',
    padding: '8px',
    paddingBottom: '30px',
    width: '64px',
    verticalAlign: 'top'
  },
  categoryItemStyle: {
    display: 'flex'
  },
  iconContainer: {
    width: '40px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'row',
    alignContent: 'space-between'
  },
  iconStyle: {
    height: '40px',
    width: '40px'
  },
  sectionHeaderIcon: {
    height: '64px',
    width: '64px'
  },
  checkBoxStyle: {
    width: '24px',
    height: '24px',
    padding: '0',
    margin: '0'
  },
  labelStyle: {
    wordBreak: 'break-all',
    hypens: 'auto',
    color: '#1976D2',
    fontFamily: 'Roboto-Light, Roboto',
    fontSize: '14px'
  },
  radioButton: {
    display: 'inline-block',
    width: '100px'
  },
  radioGroup: {
    display: 'inline-block',
    verticalAlign: 'middle'
  },
  textField: {
    marginBottom: '1rem',
    width: '100%'
  },
  checkbox: {
    marginBottom: '1rem'
  },
  checkboxLabel: {
    width: '100%'
  },
  form: {
    marginTop: '15px',
    paddingTop: '15px',
    height: '100%'
  },
  saveButton: {
    marginLeft: '1rem'
  },
  marg: {
    marginTop: '1rem'
  }
}

class ReviewOfSystemsForm extends bindTargetMixin(Component) {
  constructor (props) {
    super(props)
    this.state = {
      value: props.initialValues
    }

    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleAnchorClick = this.handleAnchorClick.bind(this)
  }

  renderCategories (categories) {
    return categories.map((category, index) => (
      <div
        className='category-container'
        key={`ROS-Category-${index}`}
      >
        <div className='ros-icon-container'>
          {category.component}
          <div className='ros-check-container'>
            <CheckboxInput name={`${category.name}Reviewed`} />
          </div>
        </div>
        <div
          className='label-container'
          lang='en'
        >
          <span>
            {' '}
            {category.label}
            {' '}
          </span>
        </div>
      </div>
    ))
  }

  componentDidUpdate (prevProps, prevState) {
    const keys = Object.keys(this.state.value)

    keys.forEach(key => {
      const keyWords = _.words(
        key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toLowerCase())
      )
      const keyGroup = keyWords[0]
      let prev
      let next

      if (prevState.value[`${keyGroup}Reviewed`]) {
        prev = 'true'
      }
      if (prevState.value[`${keyGroup}Reviewed`] === false) {
        prev = 'false'
      }

      if (this.state.value[`${keyGroup}Reviewed`]) {
        next = 'true'
      }
      if (this.state.value[`${keyGroup}Reviewed`] === false) {
        next = 'false'
      }

      const areThereValues = []

      keys.forEach(k => {
        if (
          !k.includes('Reviewed') &&
          k.includes(keyGroup) &&
          this.state.value[k]
        ) {
          areThereValues.push(k)
        }
      })

      if (prev !== next && next === 'true') {
        if (
          !key.includes('Reviewed') &&
          !key.includes('OtherText') &&
          this.state.value[key]
        ) {
          const newValue = this.state.value
          newValue[key] = false

          this.setState({
            value: { ...newValue }
          })
        }
        if (key.includes('OtherText') && this.state.value[key]) {
          const newValue = this.state.value
          newValue[key] = ''
          this.setState({
            value: { ...newValue }
          })
        }
        if (key.includes('Reviewed') && !this.state.value[key]) {
          const newValue = this.state.value
          newValue[`${keyGroup}Reviewed`] = true
          this.setState({
            value: { ...newValue }
          })
        }
      }

      if (next === 'true' && prev === next && areThereValues.length) {
        const newValue = this.state.value
        newValue[`${keyGroup}Reviewed`] = false
        this.setState({
          value: { ...newValue }
        })
      }

      if (
        key.includes('OtherText') &&
        this.state.value[key] &&
        !this.state.value[`${keyGroup}Other`]
      ) {
        const newValue = this.state.value
        newValue[`${keyGroup}Other`] = true
        this.setState({
          value: { ...newValue }
        })
      }

      if (
        !this.state.value[`${keyGroup}OtherText`] &&
        this.state.value[`${keyGroup}Other`]
      ) {
        const newValue = this.state.value
        newValue[`${keyGroup}Other`] = false
        this.setState({
          value: { ...newValue }
        })
      }
    })
  }

  renderGeneral () {
    const header = {
      icon: (
        <Svg
          style={style.sectionHeaderIcon}
          src='rosGeneral'
        />
      ),
      label: 'General',
      mapping: ROS.general,
      type: 'RoS'
    }

    return (
      <div className='relative'>
        <div
          className='anchor'
          id='general'
        />

        <SectionHeader
          name='generalReviewed'
          header={header}
        />
        <GeneralForm name='general' />
      </div>
    )
  }

  renderEnte () {
    const header = {
      icon: (
        <Svg
          style={style.sectionHeaderIcon}
          src='rosEnte'
        />
      ),
      label: 'Ears, Nose, Throat & Eyes',
      mapping: ROS.ente,
      type: 'RoS'
    }

    return (
      <div className='relative'>
        <div
          id='ente'
          className='anchor'
        />

        <SectionHeader
          name='enteReviewed'
          header={header}
        />
        <EnteForm name='ente' />
      </div>
    )
  }

  renderRespiratory () {
    const header = {
      icon: (
        <Svg
          style={style.sectionHeaderIcon}
          src='rosRespiratory'
        />
      ),
      label: 'Respiratory',
      mapping: ROS.respiratory,
      type: 'RoS'
    }

    return (
      <div className='relative'>
        <div
          id='respiratory'
          className='anchor'
        />

        <SectionHeader
          name='respiratoryReviewed'
          header={header}
        />
        <RespiratoryForm name='respiratory' />
      </div>
    )
  }

  renderCardiovascular () {
    const header = {
      icon: (
        <Svg
          style={style.sectionHeaderIcon}
          src='rosCardiovascular'
        />
      ),
      label: 'Cardiovascular',
      mapping: ROS.cardiovascular,
      type: 'RoS'
    }

    return (
      <div className='relative'>
        <div
          id='cardiovascular'
          className='anchor'
        />

        <SectionHeader
          name='cardiovascularReviewed'
          header={header}
        />
        <CardiovascularForm name='cardiovascular' />
      </div>
    )
  }

  renderDigestive () {
    const header = {
      icon: (
        <Svg
          style={style.sectionHeaderIcon}
          src='rosDigestive'
        />
      ),
      label: 'Gastrointestinal',
      mapping: ROS.digestive,
      type: 'RoS'
    }

    return (
      <div className='relative'>
        <div
          id='gastrointestinal'
          className='anchor'
        />

        <SectionHeader
          name='digestiveReviewed'
          header={header}
        />
        <DigestiveForm name='digestive' />
      </div>
    )
  }

  renderGenitourinary () {
    const header = {
      icon: (
        <Svg
          style={style.sectionHeaderIcon}
          src='rosGenitourinary'
        />
      ),
      label: 'Genitourinary',
      mapping: ROS.genitourinary,
      type: 'RoS'
    }

    return (
      <div className='relative'>
        <div
          id='genitourinary'
          className='anchor'
        />

        <SectionHeader
          name='genitourinaryReviewed'
          header={header}
        />
        <GenitourinaryForm name='genitourinary' />
      </div>
    )
  }

  renderMusculoskeletal () {
    const header = {
      icon: (
        <Svg
          style={style.sectionHeaderIcon}
          src='rosMusculoskeletal'
        />
      ),
      label: 'Musculoskeletal',
      mapping: ROS.musculoskeletal,
      type: 'RoS'
    }

    return (
      <div className='relative'>
        <div
          id='musculoskeletal'
          className='anchor'
        />

        <SectionHeader
          name='musculoskeletalReviewed'
          header={header}
        />
        <MusculoskeletalForm name='musculoskeletal' />
      </div>
    )
  }

  renderNeurological () {
    const header = {
      icon: (
        <Svg
          style={style.sectionHeaderIcon}
          src='rosNeurological'
        />
      ),
      label: 'Neurological',
      mapping: ROS.neurological,
      type: 'RoS'
    }

    return (
      <div className='relative'>
        <div
          id='neurological'
          className='anchor'
        />

        <SectionHeader
          name='neurologicalReviewed'
          header={header}
        />
        <NeurologicalForm name='neurological' />
      </div>
    )
  }

  renderIntegumentary () {
    const header = {
      icon: (
        <Svg
          style={style.sectionHeaderIcon}
          src='rosIntegumentary'
        />
      ),
      label: 'Integumentary',
      mapping: ROS.integumentary,
      type: 'RoS'
    }

    return (
      <div className='relative'>
        <div
          id='integumentary'
          className='anchor'
        />

        <SectionHeader
          name='integumentaryReviewed'
          header={header}
        />
        <IntegumentaryForm name='integumentary' />
      </div>
    )
  }

  renderMentalHealth () {
    const header = {
      icon: (
        <Svg
          style={style.sectionHeaderIcon}
          src='rosMentalhealth'
        />
      ),
      label: 'Psychiatric',
      mapping: ROS.mentalhealth,
      type: 'RoS'
    }

    return (
      <div className='relative'>
        <div
          id='psychiatric'
          className='anchor'
        />

        <SectionHeader
          name='mentalhealthReviewed'
          header={header}
        />
        <MentalHealthForm name='mentalhealth' />
      </div>
    )
  }

  renderEndocrine () {
    const header = {
      icon: (
        <Svg
          style={style.sectionHeaderIcon}
          src='rosEndocrine'
        />
      ),
      label: 'Endocrine',
      mapping: ROS.endocrine,
      type: 'RoS'
    }

    return (
      <div className='relative'>
        <div
          id='endocrine'
          className='anchor'
        />

        <SectionHeader
          name='endocrineReviewed'
          header={header}
        />
        <EndocrineForm name='endocrine' />
      </div>
    )
  }

  renderHematologic () {
    const header = {
      icon: (
        <Svg
          style={style.sectionHeaderIcon}
          src='rosHematologic'
        />
      ),
      label: 'Hematologic | Lymphatic',
      mapping: ROS.hematologic,
      type: 'RoS'
    }

    return (
      <div className='relative'>
        <div
          id='hematologic'
          className='anchor'
        />

        <SectionHeader
          name='hematologicReviewed'
          header={header}
        />
        <HematologicForm name='hematologic' />
      </div>
    )
  }

  renderAllergies () {
    const header = {
      icon: (
        <Svg
          style={style.sectionHeaderIcon}
          src='rosAllergies'
        />
      ),
      label: 'Allergic | Immunologic',
      mapping: ROS.allergies,
      type: 'RoS'
    }

    return (
      <div className='relative'>
        <div
          id='allergies'
          className='anchor'
        />

        <SectionHeader
          name='allergiesReviewed'
          header={header}
        />
        <AllergiesForm name='allergies' />
      </div>
    )
  }

  getValues () {
    return { ...this.state.value }
  }

  handleSubmit () {
    const { onSubmit } = this.props
    onSubmit(this.getValues())
  }

  handleAnchorClick (event) {
    let { hash } = event.currentTarget

    if (typeof hash !== 'string') {
      return
    }

    let element = document.querySelector(hash)

    if (!element) {
      return
    }

    event.preventDefault()
    event.stopPropagation()

    element.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  render () {
    const categories = [
      {
        component: (
          <a
            href='#general'
            onClick={this.handleAnchorClick}
          >
            <Svg
              style={style.iconStyle}
              src='rosGeneral'
            />
          </a>
        ),
        label: 'General',
        mapping: ROS.general,
        fields: this.state.general,
        type: 'checkbox',
        name: 'general'
      },
      {
        component: (
          <a
            href='#ente'
            onClick={this.handleAnchorClick}
          >
            <Svg
              style={style.iconStyle}
              src='rosEnte'
            />
          </a>
        ),
        label: 'ENT & Eyes',
        mapping: ROS.ente,
        fields: this.state.ente,
        type: 'checkbox',
        name: 'ente'
      },
      {
        component: (
          <a
            href='#respiratory'
            onClick={this.handleAnchorClick}
          >
            <Svg
              style={style.iconStyle}
              src='rosRespiratory'
            />
          </a>
        ),
        label: 'Respiratory',
        mapping: ROS.respiratory,
        fields: this.state.respiratory,
        type: 'checkbox',
        name: 'respiratory'
      },
      {
        component: (
          <a
            href='#cardiovascular'
            onClick={this.handleAnchorClick}
          >
            <Svg
              style={style.iconStyle}
              src='rosCardiovascular'
            />
          </a>
        ),
        label: 'Cardiovascular',
        mapping: ROS.cardiovascular,
        fields: this.state.cardiovascular,
        type: 'checkbox',
        name: 'cardiovascular'
      },
      {
        component: (
          <a
            href='#gastrointestinal'
            onClick={this.handleAnchorClick}
          >
            <Svg
              style={style.iconStyle}
              src='rosDigestive'
            />
          </a>
        ),
        label: 'Gastrointestinal',
        mapping: ROS.digestive,
        fields: this.state.digestive,
        type: 'checkbox',
        name: 'digestive'
      },
      {
        component: (
          <a
            href='#genitourinary'
            onClick={this.handleAnchorClick}
          >
            <Svg
              style={style.iconStyle}
              src='rosGenitourinary'
            />
          </a>
        ),
        label: 'Genitourinary',
        mapping: ROS.genitourinary,
        fields: this.state.genitourinary,
        type: 'checkbox',
        name: 'genitourinary'
      },
      {
        component: (
          <a
            href='#musculoskeletal'
            onClick={this.handleAnchorClick}
          >
            <Svg
              style={style.iconStyle}
              src='rosMusculoskeletal'
            />
          </a>
        ),
        label: 'Musculoskeletal',
        mapping: ROS.musculoskeletal,
        fields: this.state.musculoskeletal,
        type: 'checkbox',
        name: 'musculoskeletal'
      },
      {
        component: (
          <a
            href='#neurological'
            onClick={this.handleAnchorClick}
          >
            <Svg
              style={style.iconStyle}
              src='rosNeurological'
            />
          </a>
        ),
        label: 'Neurological',
        mapping: ROS.neurological,
        fields: this.state.neurological,
        type: 'checkbox',
        name: 'neurological'
      },
      {
        component: (
          <a
            href='#integumentary'
            onClick={this.handleAnchorClick}
          >
            <Svg
              style={style.iconStyle}
              src='rosIntegumentary'
            />
          </a>
        ),
        label: 'Integumentary',
        mapping: ROS.integumentary,
        fields: this.state.integumentary,
        type: 'checkbox',
        name: 'integumentary'
      },
      {
        component: (
          <a
            href='#psychiatric'
            onClick={this.handleAnchorClick}
          >
            <Svg
              style={style.iconStyle}
              src='rosMentalhealth'
            />
          </a>
        ),
        label: 'Psychiatric',
        mapping: ROS.mentalhealth,
        fields: this.state.mentalhealth,
        type: 'checkbox',
        name: 'mentalhealth'
      },
      {
        component: (
          <a
            href='#endocrine'
            onClick={this.handleAnchorClick}
          >
            <Svg
              style={style.iconStyle}
              src='rosEndocrine'
            />
          </a>
        ),
        label: 'Endocrine',
        mapping: ROS.endocrine,
        fields: this.state.endocrine,
        type: 'checkbox',
        name: 'endocrine'
      },
      {
        component: (
          <a
            href='#hematologic'
            onClick={this.handleAnchorClick}
          >
            <Svg
              style={style.iconStyle}
              src='rosHematologic'
            />
          </a>
        ),
        label: 'Hematologic | Lymphatic',
        mapping: ROS.hematologic,
        fields: this.state.hematologic,
        type: 'checkbox',
        name: 'hematologic'
      },
      {
        component: (
          <a
            href='#allergies'
            onClick={this.handleAnchorClick}
          >
            <Svg
              style={style.iconStyle}
              src='rosAllergies'
            />
          </a>
        ),
        label: 'Allergic | Immunologic',
        mapping: ROS.allergies,
        fields: this.state.allergies,
        type: 'checkbox',
        name: 'allergies'
      }
    ]

    return (
      <form style={style.form}>
        <div
          className='row'
          style={{ marginBottom: '1em' }}
        >
          <div className='categories-container'>
            {this.renderCategories(categories)}
          </div>
        </div>
        {this.renderGeneral()}
        {this.renderEnte()}
        {this.renderRespiratory()}
        {this.renderCardiovascular()}
        {this.renderDigestive()}
        {this.renderGenitourinary()}
        {this.renderMusculoskeletal()}
        {this.renderNeurological()}
        {this.renderIntegumentary()}
        {this.renderMentalHealth()}
        {this.renderEndocrine()}
        {this.renderHematologic()}
        {this.renderAllergies()}

        <div
          className='row end-xs'
          style={style.marg}
        >
          <div className='col-xs-12'>
            <CancelButton
              formKey={this.props.formKey}
              onClick={this.props.cancel}
            />

            <SaveButton
              formKey={this.props.formKey}
              onClick={this.handleSubmit}
            />
          </div>
        </div>
      </form>
    )
  }
}

export default ReviewOfSystemsForm
